import { computed } from 'mobx';
import FileModel    from './globals/FileModel';

export default class DemandMediaModel extends FileModel {
  static get path() {
    return '/backend/demand_media/{?id}';
  }

  @computed
  get mediaFileName() {
    return this.get('mediaFileName');
  }

  @computed
  get objectUrl() {
    return this.get('objectUrl');
  }

  @computed
  get demandId() {
    return this.get('message.id');
  }

  @computed
  get language() {
    return this.get('language');
  }
}
